import {
  CONDITION,
  DOMAIN_CARD,
} from '../../character/content/templates';

export default function Combat() {
  return (
    <>
      <p>Though Daggerheart relies on the same flow of collaborative storytelling in and out of combat, physical conflicts rely more heavily on several key mechanics related to attacking, maneuvering, and taking damage.</p>

      <h3 id="evasion">EVASION</h3>
      <p><strong>Evasion</strong> represents a character's ability to avoid attacks and other unwanted effects. Any roll made against a PC has a Difficulty equal to the target's <strong>Evasion</strong>. A PC's base <strong>Evasion</strong> is determined by their class, but can be modified by {DOMAIN_CARD}s, equipment, {CONDITION}s, and other effects.</p>
      <p className="rule-note"><strong>Note:</strong> attacks rolled against adversaries use the target's Difficulty instead of <strong>Evasion</strong>.</p>

      <h3 id="hit-points-damage-thresholds">HIT POINTS &amp; DAMAGE THRESHOLDS</h3>
      <p><strong>Hit Points (HP)</strong> represent a character's ability to withstand physical injury. When a character takes damage, they mark 1 to 3 <strong>Hit Points</strong>, based on their <strong>damage thresholds</strong>:</p>
      <ul>
        <li>If the final damage is at or above the character's Severe damage threshold, they mark 3 <strong>Hit Points</strong>.</li>
        <li>If the final damage is at or above the character's Major damage threshold but below their Severe damage threshold, they mark 2 <strong>Hit Points</strong>.</li>
        <li>If the final damage is below the character's Major damage threshold, they mark 1 <strong>Hit Point</strong>.</li>
        <li>If incoming damage is ever reduced to 0 or less, no <strong>Hit Points</strong> are marked.</li>
      </ul>
      <p>You'll be able to increase the number of <strong>Hit Points</strong> you have available as you level up, to a maximum of 12.</p>
      <p>A PC's damage thresholds are calculated by adding their level to the listed damage thresholds of their equipped armor. A PC's starting HP is based on their class, but they can gain additional <strong>Hit Points</strong> through advancements, features, and other effects.</p>
      <p>An adversary's Damage Thresholds and HP are listed in their stat blocks.</p>
      <p>When a character marks their last <strong>Hit Point</strong>, they fall. If a PC falls, they make a death move.</p>
      <p>Characters can clear <strong>Hit Points</strong> by taking downtime moves or by activating relevant special abilities or effects.</p>
      <p className="rule-note"><strong>Optional Rule: Massive Damage</strong><br /><br />
        If a character ever takes damage equal to twice their Severe threshold, they mark 4 HP instead of 3.
      </p>
    </>
  );
}
